module.exports = __webpack_public_path__ + "static/media/jcb.eace828a.png";